import { useState, useEffect, useRef } from "react";
import {
  Grid,
  Dialog,
  Box,
  Button,
  Typography,
  IconButton,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Noimage from "../../../../Image/No.png";
import signImages from "../../../../Image/sign.png";
import signsuccess from "../../../../Image/signsuccess.png";
import Swal from "sweetalert2";
import Signature_Drawing from "../../../../Image/Drawing.png";
import draw from "../../../../Image/draw.png";
import SignatureCanvas from "react-signature-canvas";
import { APIEndpointWeb, GetLocalStorageAccessToken, webapi } from "../../../../client/web";
import dayjs from "dayjs";
import { useHistory } from "react-router-dom";
import { PPHOMember } from "./IndexPendingDocument";
import cloneDeep from "lodash/cloneDeep";
import { xywhOfPDF } from "../DocumentPersonalComponent/SignSignatureDialog";
import { PdfArray } from "../DocumentPersonalComponent/IndexDocumentPer";
import DialogShowSignPDFV1 from "../FormPersonal/DialogShowSignPDFV1";


interface DrawSignatureModalProps {
  open: boolean;
  onClose: () => void;
  onSign: (signature: string) => void;
  getBase64OfSign: string
  setLoading: (value: boolean) => void;
  dataPageForm: any;
  localStorageData: any
  localStorageOrganization: any
  approverAutocomplet:PPHOMember
  docNumber: string
  arrrayOfPdf: any
}

const DrawSignatureModal: React.FC<DrawSignatureModalProps> = ({ open, onClose, onSign, getBase64OfSign, setLoading, dataPageForm, localStorageData, localStorageOrganization , approverAutocomplet, docNumber, arrrayOfPdf}) => {
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false); // 🔹 Dialog 3: ยืนยันการเซ็น
    const [openSuccessDialog, setOpenSuccessDialog] = useState(false); // 🔹 Dialog 4: เซ็นสำเร็จ
    const [comment, setComment] = useState("");
    const [isLoading, setLoadingState] = useState(false); // สำหรับแสดงสถานะโหลด
    const maxCharacters = 100;
    const [isSigned, setIsSigned] = useState(false);
    const [penColor, setPenColor] = useState("black");
    const [selectedColor, setSelectedColor] = useState("black");

  const [base64OfSignDraggable, setBase64OfSignDraggable] = useState<string | null>(null);
  const [openPDF1, setOpenPDF1] = useState<boolean>(false);
  const [openPDF2, setOpenPDF2] = useState<boolean>(false);
  const [xywhOfPDF1, setXywhOfPDF1] = useState<xywhOfPDF>({doc_type: "",x: "", y: "", width: "", height: ""});
  const [xywhOfPDF2, setXywhOfPDF2] = useState<xywhOfPDF>({doc_type: "",x: "", y: "", width: "", height: ""});
  const [pageOfSignPDF1, setPageOfSignPDF1] = useState<number>(1);
  const [pageOfSignPDF2, setPageOfSignPDF2] = useState<number>(1);
  const [base64OfPDF1, setBase64OfPDF1] = useState<PdfArray>({} as PdfArray);
  const [base64OfPDF2, setBase64OfPDF2] = useState<PdfArray>({} as PdfArray);


    const signatureRef = useRef<SignatureCanvas | null>(null);
    const handleCloseConfirmDialog = () => setOpenConfirmDialog(false);
    const handleCloseSuccessDialog = () => setOpenSuccessDialog(false);
      const history = useHistory();

    useEffect(() => {
        if (!open) {
          // console.log("first", open)
          handleClearSignature()
        }
    }, [open]);


    useEffect(() => {
      if (arrrayOfPdf.length >= 2) {
        if (dataPageForm.priority !== "1") {
          var arrrayOfPdfclone = cloneDeep(arrrayOfPdf)
          var base64Register  = arrrayOfPdfclone.find((dataPdfArray : PdfArray) => {
              return dataPdfArray.type.toLowerCase() === "dsa"
            })
            if (base64Register) {
              base64Register.type = base64Register.type.toLowerCase()
              setBase64OfPDF1(base64Register);
            }
        } else {
             var arrrayOfPdfclone = cloneDeep(arrrayOfPdf)
            var base64Register  = arrrayOfPdfclone.find((dataPdfArray : PdfArray) => {
                    return dataPdfArray.type.toLowerCase() === "register"
                  })
                  if (base64Register) {
                    base64Register.type = base64Register.type.toLowerCase()
                    setBase64OfPDF1(base64Register);
                  }
                  
                var base6Dsa  = arrrayOfPdfclone.find((dataPdfArray : PdfArray) => {
                    return dataPdfArray.type.toLowerCase() === "dsa"
                  })
                  if (base6Dsa) {
                    base6Dsa.type = base6Dsa.type.toLowerCase()
                    setBase64OfPDF2(base6Dsa);
                  }
        }
    
      }
    }, [arrrayOfPdf]);
  
  const handleSave = () => {
      setOpenConfirmDialog(true);
      // onClose();
    };

    const handleOpenSignaturePDF = async () => {
      if (getBase64OfSign === "") {
        var base64result = signatureRef.current?.toDataURL().substr(signatureRef.current?.toDataURL().indexOf(',') + 1);
        // console.log(base64result)
        if (base64result) {
          setBase64OfSignDraggable(base64result);
          // dataPageFormApi.sign_new_image = base64result
        }
      } else {
        setBase64OfSignDraggable(getBase64OfSign)
      }
      setOpenPDF1(true)
    }
  
  const handleConfirmSave = async () => {
    var accessToken = await GetLocalStorageAccessToken()
          // console.log("signatureRef", signatureRef)
    // try {
    // setLoading(true)
    //   if (getBase64OfSign === "") {
    //   var base64result = signatureRef.current?.toDataURL().substr(signatureRef.current?.toDataURL().indexOf(',') + 1);
    //    var { data } = await webapi.post(`${APIEndpointWeb.PostCreateSignatureImage}`,
    //      {
    //       provider_access_token: accessToken,
    //       image: base64result,
    //       type: "001"
    //      },{headers: { Authorization: `Bearer ${accessToken}` }});
    //  }
    // } catch (error) {
    //   console.log(error)
    //   Swal.fire({
    //     title: "สร้างลายเซ็นต์ไม่สำเร็จ",
    //     // text: `ไฟล์ "${file.name}" ไม่ใช่ PDF`,
    //     icon: "error",
    //  });
    //   setLoading(false)
    //   return false
    // } finally {
    //   setLoading(false)
    // }
    try {
      setOpenConfirmDialog(false); // ปิด Dialog 3
      setLoading(true)
      //  console.log("localStorageData", localStorageData)
      //  console.log("dataPageForm", dataPageForm)
      //  console.log("localStorageOrganization", localStorageOrganization)

      // var dataPageFormApi = Object.assign({}, dataPageForm)

      // var dataPageFormApi = structuredClone(dataPageForm)
       var dataPageFormApi = cloneDeep(dataPageForm);
      if (getBase64OfSign === "") {
        var base64result = await signatureRef.current?.toDataURL().substr(signatureRef.current?.toDataURL().indexOf(',') + 1);
        dataPageFormApi.sign_new_image = base64result
       }
       if (dataPageFormApi.priority === "1" && dataPageFormApi.approve_list && dataPageFormApi.approve_list.length > 3) {
         dataPageFormApi.access_token = accessToken
         dataPageFormApi.status_user = "approved"
         dataPageFormApi.priority = "1"

         dataPageFormApi.one_id = localStorageData?.data?.account_id ? localStorageData.data.account_id : ""
         dataPageFormApi.name =  localStorageData?.data?.name_th ?  localStorageData?.data?.name_th: ""
         dataPageFormApi.provider_id = localStorageData?.data?.provider_id ? localStorageData.data.provider_id : ""
         dataPageFormApi.cid = localStorageData?.data?.full_cid ? localStorageData.data.full_cid : ""


         dataPageFormApi.approve_list[0].comment = comment
         dataPageFormApi.approve_list[0].status = "approved"
         dataPageFormApi.approve_list[0].one_id = localStorageData?.data?.account_id ? localStorageData.data.account_id : ""
         dataPageFormApi.approve_list[0].email = localStorageData?.data?.email ? localStorageData.data.email : ""
         dataPageFormApi.approve_list[0].provider_id =  localStorageData?.data?.provider_id ? localStorageData.data.provider_id : ""
         dataPageFormApi.approve_list[0].position =  localStorageOrganization?.position ? localStorageOrganization.position : "" 
         dataPageFormApi.approve_list[0].name =  localStorageData?.data?.name_th ? localStorageData.data.name_th : ""
         dataPageFormApi.approve_list[0].prefix = localStorageData?.data?.title_th ? localStorageData?.data?.title_th : ""
         dataPageFormApi.approve_list[0].cid =  localStorageData?.data?.full_cid ? localStorageData.data.full_cid : ""
         dataPageFormApi.approve_list[0].update_time =  dayjs().format('YYYY-MM-DD HH:mm:ss')

       } else if (dataPageFormApi.priority === "2" && dataPageFormApi.approve_list && dataPageFormApi.approve_list.length > 3) {
       dataPageFormApi.access_token = accessToken
       dataPageFormApi.status_user = "approved"
       dataPageFormApi.priority = "2"

       dataPageFormApi.one_id = localStorageData?.data?.account_id ? localStorageData.data.account_id : ""
       dataPageFormApi.name =  localStorageData?.data?.name_th ?  localStorageData?.data?.name_th: ""
       dataPageFormApi.provider_id = localStorageData?.data?.provider_id ? localStorageData.data.provider_id : ""
       dataPageFormApi.cid = localStorageData?.data?.full_cid ? localStorageData.data.full_cid : ""

       dataPageFormApi.approve_list[1].comment = comment
       dataPageFormApi.approve_list[1].status = "approved"
       dataPageFormApi.approve_list[1].one_id = localStorageData?.data?.account_id ? localStorageData.data.account_id : ""
       dataPageFormApi.approve_list[1].email = localStorageData?.data?.email ? localStorageData.data.email : ""
       dataPageFormApi.approve_list[1].provider_id =  localStorageData?.data?.provider_id ? localStorageData.data.provider_id : ""
       dataPageFormApi.approve_list[1].position =  localStorageOrganization?.position ? localStorageOrganization.position : "" 
       dataPageFormApi.approve_list[1].name =  localStorageData?.data?.name_th ? localStorageData.data.name_th : ""
       dataPageFormApi.approve_list[1].prefix = localStorageData?.data?.title_th ? localStorageData?.data?.title_th : ""
       dataPageFormApi.approve_list[1].cid =  localStorageData?.data?.full_cid ? localStorageData.data.full_cid : ""
       dataPageFormApi.approve_list[1].update_time =  dayjs().format('YYYY-MM-DD HH:mm:ss')
       // dataPageFormApi.approve_list

       
      } else if (dataPageFormApi.priority === "3" && dataPageFormApi.approve_list && dataPageFormApi.approve_list.length > 3) {
        // console.log("approverAutocomplet", approverAutocomplet)
        // console.log("docNumber", docNumber)
        dataPageFormApi.access_token = accessToken
        dataPageFormApi.status_user = "approved"
        dataPageFormApi.priority = "3"
        dataPageFormApi.register_no = docNumber

        dataPageFormApi.one_id = localStorageData?.data?.account_id ? localStorageData.data.account_id : ""
        dataPageFormApi.name =  localStorageData?.data?.name_th ?  localStorageData?.data?.name_th: ""
        dataPageFormApi.provider_id = localStorageData?.data?.provider_id ? localStorageData.data.provider_id : ""
        dataPageFormApi.cid = localStorageData?.data?.full_cid ? localStorageData.data.full_cid : ""
 
        dataPageFormApi.approve_list[2].comment = comment
        dataPageFormApi.approve_list[2].status = "approved"
        dataPageFormApi.approve_list[2].one_id = localStorageData?.data?.account_id ? localStorageData.data.account_id : ""
        dataPageFormApi.approve_list[2].email = localStorageData?.data?.email ? localStorageData.data.email : ""
        dataPageFormApi.approve_list[2].provider_id =  localStorageData?.data?.provider_id ? localStorageData.data.provider_id : ""
        dataPageFormApi.approve_list[2].position =  localStorageOrganization?.position ? localStorageOrganization.position : "" 
        dataPageFormApi.approve_list[2].name =  localStorageData?.data?.name_th ? localStorageData.data.name_th : ""
        dataPageFormApi.approve_list[2].prefix = localStorageData?.data?.title_th ? localStorageData?.data?.title_th : ""
        dataPageFormApi.approve_list[2].cid =  localStorageData?.data?.full_cid ? localStorageData.data.full_cid : ""
        dataPageFormApi.approve_list[2].update_time =  dayjs().format('YYYY-MM-DD HH:mm:ss')


        dataPageFormApi.approve_list[3].status = "waiting"
        dataPageFormApi.approve_list[3].one_id = approverAutocomplet.account_id  ? approverAutocomplet.account_id : ""
        dataPageFormApi.approve_list[3].email = approverAutocomplet.email ? approverAutocomplet.email : ""
        dataPageFormApi.approve_list[3].cid =  approverAutocomplet.cid ? approverAutocomplet.cid : ""
        // dataPageFormApi.approve_list[2].provider_id =  localStorageData?.data?.provider_id ? localStorageData.data.provider_id : ""
        dataPageFormApi.approve_list[3].prefix = approverAutocomplet.prefix ? approverAutocomplet.prefix : ""
        dataPageFormApi.approve_list[3].position = approverAutocomplet.position ? approverAutocomplet.position : ""
        dataPageFormApi.approve_list[3].name = approverAutocomplet.name  ? approverAutocomplet.name : ""
        // dataPageFormApi.approve_list[3].update_time =  dayjs().format('YYYY-MM-DD HH:mm:ss')

      } else if (dataPageFormApi.priority === "4" && dataPageFormApi.approve_list && dataPageFormApi.approve_list.length > 3) {

      dataPageFormApi.access_token = accessToken
       dataPageFormApi.status_user = "approved"
       dataPageFormApi.priority = "4"

       dataPageFormApi.one_id = localStorageData?.data?.account_id ? localStorageData.data.account_id : ""
       dataPageFormApi.name =  localStorageData?.data?.name_th ?  localStorageData?.data?.name_th: ""
       dataPageFormApi.provider_id = localStorageData?.data?.provider_id ? localStorageData.data.provider_id : ""
       dataPageFormApi.cid = localStorageData?.data?.full_cid ? localStorageData.data.full_cid : ""

       dataPageFormApi.approve_list[3].comment = comment
       dataPageFormApi.approve_list[3].status = "approved"
       dataPageFormApi.approve_list[3].one_id = localStorageData?.data?.account_id ? localStorageData.data.account_id : ""
       dataPageFormApi.approve_list[3].email = localStorageData?.data?.email ? localStorageData.data.email : ""
       dataPageFormApi.approve_list[3].provider_id =  localStorageData?.data?.provider_id ? localStorageData.data.provider_id : ""
       dataPageFormApi.approve_list[3].position =  localStorageOrganization?.position ? localStorageOrganization.position : "" 
       dataPageFormApi.approve_list[3].name =  localStorageData?.data?.name_th ? localStorageData.data.name_th : ""
       dataPageFormApi.approve_list[3].prefix = localStorageData?.data?.title_th ? localStorageData?.data?.title_th : ""
       dataPageFormApi.approve_list[3].cid =  localStorageData?.data?.full_cid ? localStorageData.data.full_cid : ""
       dataPageFormApi.approve_list[3].update_time =  dayjs().format('YYYY-MM-DD HH:mm:ss')
      }

      if (dataPageForm.priority !== "1") {
        dataPageFormApi.sign_image_position =[{...xywhOfPDF1, page:pageOfSignPDF1}]
      } else {
        dataPageFormApi.sign_image_position =[{...xywhOfPDF1, page:pageOfSignPDF1},{...xywhOfPDF2, page:pageOfSignPDF2}]
      }
  //  console.log("dataPageFormApi", dataPageFormApi)      // console.log("localStorageDataxxxxxxxxxxxxxx", dataPageFormApi)
      //  return false
     var { data } = await webapi.post(`${APIEndpointWeb.PostcadDocument}`,dataPageFormApi,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      
      setOpenSuccessDialog(true); // เปิด Dialog 4
      // }, 2000); // โหลด 2 วินาที
  
      setTimeout(() => {
        setOpenSuccessDialog(false); // ปิด Dialog 4 หลังจาก 2 วินาที
        let params = new URLSearchParams(document.location.search);
        let page = params.get("page");

        window.location.replace(page === "1"? "/document-personal" :page === "2" ? "/pending-document" : page === "3" ? "/admin-page-document" : "/public-health")
        // history.push(page === "2" ? "/pending-document" : page === "3" ? "/admin-page-document" : "/public-health");
      }, 3000); // 4 วินาทีจากจุดเริ่มต้น
      setLoading(false)
    } catch (error: any) {
      setLoading(false)
      console.log("error", error)
    try {
        Swal.fire({
          title: error.response.data.status_result.status_message_th,
          icon: "error",
            });
      } catch (error) {
        Swal.fire({
          title: "เซ็นเอกสารไม่สำเร็จ",
          icon: "error",
        });
      }

    } finally {
      setLoading(false)
    }
  };
  
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      let inputValue = event.target.value;
  
      // ตรวจสอบว่าอักขระแรกเป็น space หรือไม่
      if (inputValue.startsWith(" ")) {
        return; // ไม่อัปเดต state ถ้าเริ่มด้วย space
      }
  
      // จำกัดตัวอักษรสูงสุด
      if (inputValue.length <= maxCharacters) {
        setComment(inputValue);
      }
    };
  
    const handleClearSignature = async() => {
      // console.log(signatureRef.current?.toDataURL())
      await signatureRef.current?.clear();
      //  signatureRef.current = null
      setIsSigned(false);
      // console.log("signatureRef", signatureRef)
      // console.log("signatureRef.current?.toDataURL()", signatureRef.current?.isEmpty())
      // setComment("");
    };
  
    const handlePenColorChange = (color: string) => {
      handleClearSignature()
      setSelectedColor(color);
      setPenColor(color); // 🔹 เพิ่มการอัปเดตสีของปากกา
    };
    // useEffect(() => {
    //   if (!open) {
    //     setComment(""); 
    //   }
    // }, [open]);
    useEffect(() => {
      if (isLoading) {
        Swal.fire({
          title: "ระบบกำลังดำเนินการ",
          html: "กรุณารอสักครู่...",
          timerProgressBar: true,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
      } else {
        Swal.close();
      }
    }, [isLoading]);




    
  return (
    <>
    {dataPageForm.priority !== "1" ? 
                <DialogShowSignPDFV1 
                base64OfPDF={base64OfPDF1}
                checkPage={3} 
                open={openPDF1} 
                setOpen={setOpenPDF1} 
                // setOpen2={setOpenPDF2} 
                pageOfSignPDF={setPageOfSignPDF1} 
                base64OfSignDraggable={base64OfSignDraggable || ""} 
                setXywhOfPDF={setXywhOfPDF1}
                setOpenConfirmDialog={setOpenConfirmDialog}
                typeOfPDF="dsa"
                priorityOfPDF={dataPageForm.priority}
                  />  :   
        <>
        <DialogShowSignPDFV1 
            base64OfPDF={base64OfPDF1}
            checkPage={1} 
            open={openPDF1} 
            setOpen={setOpenPDF1} 
            setOpen2={setOpenPDF2} 
            pageOfSignPDF={setPageOfSignPDF1} 
            base64OfSignDraggable={base64OfSignDraggable || ""} 
            setXywhOfPDF={setXywhOfPDF1}
            typeOfPDF="register"
            priorityOfPDF={"1"}
        />
  
        <DialogShowSignPDFV1 
            base64OfPDF={base64OfPDF2}
            checkPage={2} 
            open={openPDF2} 
            setOpen={setOpenPDF2} 
            setOpen2={setOpenPDF1} 
            pageOfSignPDF={setPageOfSignPDF2} 
            base64OfSignDraggable={base64OfSignDraggable || ""} 
            setXywhOfPDF={setXywhOfPDF2}
            setOpenConfirmDialog={setOpenConfirmDialog}
            typeOfPDF="dsa"
            priorityOfPDF={"1"}
        />
      </>
        }
  
      {/* ✅ Dialog : ลงนามลายเซ็นดิจิทัล */}
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          onClose();
        }}
        disableEscapeKeyDown
        fullWidth
        maxWidth="sm" // ✅ ปรับขนาดจาก xs เป็น sm หรือ md
        PaperProps={{
          sx: {
            borderRadius: "16px",
            mx: 2,
            width: "500px", // ✅ ปรับความกว้างของ Dialog
          },
        }}
      >
        <Box sx={{ ml: 2 }}>
          <DialogTitle textAlign="center">
            <Box
              sx={{
                width: { xs: "100%", lg: "100%" }, // ขยายให้เต็มพื้นที่ของ Dialog
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between", // จัดให้อยู่บรรทัดเดียวกั
                position: "relative", // ใช้เพื่อวาง IconButton ในตำแหน่งที่ถูกต้อง
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <img
                  src={Noimage}
                  alt="รูปภาพ"
                  style={{ width: 30, height: "auto", marginRight: 8 }}
                />
                <Typography
                  variant="body1"
                  sx={{ color: "#000", fontWeight: "bold",fontSize:"18px" }}
                >
                  ลงนามลายเซ็นดิจิทัล
                </Typography>
              </Box>

              {/* ปุ่มปิด */}
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box sx={{ mt: 1 }}>
              <Divider />
            </Box>
          </DialogTitle>

          <DialogContent sx={{ display: "flex", flexDirection: "column" }}>
            <Typography sx={{ p: 1, color: "#000", fontSize: "16px" }}>
              ลายเซ็นดิจิทัล
            </Typography>
            <Box
              sx={{
                width: { xs: "95%", lg: "96%" }, // ขยายเต็มพื้นที่ของ Dialog
                height: 180,
                backgroundColor: "#fff",
                borderRadius: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #99B9F3",
                position: "relative", // ต้องใช้ relative เพื่อให้ absolute ข้างในอ้างอิงตำแหน่งถูกต้อง
                overflow: "hidden", // ป้องกันเนื้อหาเกินขอบกล่อง
              }}
            >
                {getBase64OfSign !== "" ?     
                            <Box
                              sx={{ display: "flex", justifyContent: "center", width: "100%", p: 2 }}
                            >
                              <img width={"100%"} src={"data:image/png;base64," + getBase64OfSign}  />
                            </Box>
                                 : 
                            <>
                            {!isSigned ? `รูปพื้นหลัง "กรุณาวาดลายเซ็น"` : ""}
                            {!isSigned && (
                                  <img
                                    src={Signature_Drawing}
                                    alt="กรุณาวาดลายเซ็น"
                                    style={{
                                      position: "absolute",
                                      width: "20%",
                                      height: "auto",
                                      opacity: 0.5,
                                      top: "50%", // จัดให้อยู่กึ่งกลางแนวตั้ง
                                      left: "50%", // จัดให้อยู่กึ่งกลางแนวนอน
                                      transform: "translate(-50%, -50%)", // จัดให้อยู่ตรงกลางพอดี
                                    }}
                                  />
                                )} 
                                <SignatureCanvas
                                  ref={signatureRef}
                                  penColor={penColor} // ใช้สีที่เลือก
                                  onEnd={() => setIsSigned(true)}
                                  canvasProps={{
                                    width: 460,
                                    height: 180,
                                    style: {
                                      borderRadius: "16px",
                                      backgroundColor: "transparent",
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                    },
                                  }}
                                /> 
                            </>}

            </Box>

              {getBase64OfSign !== "" ?  "" : 
                          <>  <Box
                          sx={{
                            display: "flex",
                            gap: 2,
                            justifyContent: "space-between",
                            pt: 2,
                            alignItems: "center", 
                          }}
                        >
                          <Box sx={{ display: "flex", gap: 1 }}>
                            <IconButton
                              onClick={() => handlePenColorChange("black")}
                              aria-label="black"
                              sx={{
                                width: 25,
                                height: 25,
                                backgroundColor: "black",
                                color: "#fff",
                                "&:hover": { backgroundColor: "black" },
                              }}
                            >
                              {selectedColor === "black" && (
                                <img
                                  src={draw}
                                  alt="กรุณาวาดลายเซ็น"
                                  style={{
                                    position: "absolute",
                                    width: "60%",
                                    height: "auto",
                                    opacity: 0.5,
                                    filter: "brightness(0) invert(1)",
                                  }}
                                />
                              )}
                            </IconButton>

                            <IconButton
                              onClick={() => handlePenColorChange("#0288D1")}
                              aria-label="blue"
                              sx={{
                                width: 25,
                                height: 25,
                                backgroundColor: "#0288D1",
                                color: "#fff",
                                "&:hover": { backgroundColor: "#0288D1" },
                              }}
                            >
                              {selectedColor === "#0288D1" && (
                                <img
                                  src={draw}
                                  alt="กรุณาวาดลายเซ็น"
                                  style={{
                                    position: "absolute",
                                    width: "60%",
                                    height: "auto",
                                    opacity: 0.5,
                                    filter: "brightness(0) invert(1)",
                                  }}
                                />
                              )}
                            </IconButton>
                          </Box>

                          {isSigned && (
                           <Button
                           onClick={handleClearSignature}
                           sx={{
                             backgroundColor: "red",
                             color: "#fff",
                             fontSize: "0.8em",
                             padding: "2px 10px",
                             marginRight: "20px",
                             textTransform: "none",
                             borderRadius: "20px",
                             "&:hover": { backgroundColor: "#d32f2f" },
                             ml: "0px",
                           }}
                         >
                           ล้าง
                         </Button>
                          )}
                        </Box> 
                        </>
         }

  {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between", // ปรับระยะห่างให้เหมาะสม
                  width: "100%", // ทำให้ขยายเต็มความกว้างของ container
                  p: 1,
                }}
              >
                <Typography sx={{ color: "#000", fontSize: "16px" }}>
                  ความคิดเห็น
                </Typography>
                <Typography
                  sx={{
                    color:
                      comment.length === maxCharacters ? "#D32F2F" : "grey.600",
                    fontSize: "14px",
                  }}
                >
                  {comment.length}/{maxCharacters}
                </Typography>
              </Box>
            </Box>

            <TextField
              variant="outlined"
              fullWidth
              multiline
              minRows={4}
              maxRows={6}
              placeholder="ระบุความคิดเห็น (ไม่จำเป็นต้องระบุ)"
              value={comment}
              onChange={handleChange} // ใช้ฟังก์ชันที่อัปเดตแล้ว
              sx={{
                width: { xs: "95%", lg: "96%" }, // ทำให้ขยายเต็มพื้นที่ของ Dialog
                backgroundColor: "#fff",
                borderRadius: "16px",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "1px solid #C4C4C4",
                    borderRadius: "16px",
                  },
                  "&:hover fieldset": { borderColor: "#99B9F3" },
                  "&.Mui-focused fieldset": { borderColor: "#0288D1" },
                },
              }}
              inputProps={{
                style: { fontSize: "16px" }, // ปรับขนาดตัวอักษรของข้อความที่พิมพ์
              }}
              InputProps={{
                sx: {
                  "&::placeholder": { fontSize: "16px" }, // ปรับขนาดตัวอักษรของ placeholder
                },
              }}
            />
          </DialogContent>
          <DialogActions>
            <Box
              sx={{
                width: "100%", // ใช้เต็มความกว้าง
                display: "flex",
                justifyContent: "center", // จัดให้อยู่ตรงกลางแนวนอน
              }}
            >
             <Button
                  disabled={getBase64OfSign === "" && (signatureRef.current?.isEmpty() || signatureRef.current === null)}
                  // onClick={handleSave}
                  onClick={handleOpenSignaturePDF}
                  sx={{
                    padding: "6px 40px",
                    backgroundColor: getBase64OfSign === "" && (signatureRef.current?.isEmpty() || signatureRef.current === null) ? "#E6E6E6" : "#0288D1",
                    color: "#fff",
                    borderRadius: "15px",
                    "&:hover": {
                      backgroundColor: "#0277BD",
                    },
                  }}
                >
                  บันทึก
                </Button>
            </Box>
          </DialogActions>
        </Box>
      </Dialog>

      {/* ✅ Dialog : ยืนยันการเซ็นเอกสาร */}
      <Dialog
        open={openConfirmDialog}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleCloseSuccessDialog();
          }
        }}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            bgcolor: "#FFFFFF",
            borderRadius: "20px",
            boxShadow: 3,
            p: 2,
            width: "400px",
          },
        }}
      >
        <IconButton
          onClick={handleCloseConfirmDialog}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} display="flex" justifyContent="center">
              <img
                src={signImages}
                alt="รูปภาพ"
                style={{
                  width: 160,
                  height: "auto",
                  marginBottom: "20px",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{
                  mt: -2,
                  fontFamily: "Sarabun, sans-serif",
                  textAlign: "center",
                  color: "#333333",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                ต้องการยืนยันเซ็นเอกสาร
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{
                  mt: -1,
                  fontFamily: "Sarabun, sans-serif",
                  textAlign: "center",
                  color: "#636363",
                  fontSize: "14px",
                }}
              >
                ท่านต้องการยืนยันการเซ็นเอกสารหรือไม่
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Grid container spacing={2} justifyContent="center">
            <Grid item>
              <Button
                onClick={handleCloseConfirmDialog}
                variant="outlined"
                color="error"
                sx={{
                  mt: -1,
                  width: "120px",
                  height: "40px",
                  borderRadius: "20px",
                }}
              >
                ยกเลิก
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={handleConfirmSave}
                variant="contained"
                sx={{
                  mt: -1,
                  width: "120px",
                  height: "40px",
                  backgroundColor: "#0288D1",
                  borderRadius: "20px",
                  "&:hover": { backgroundColor: "#0288D1" },
                }}
              >
                ยืนยัน
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      {/* ✅ Dialog : ยืนยันการเซ็นเอกสารสำเร็จ */}
      {/* {String(openSuccessDialog)} */}
      <Dialog
        open={openSuccessDialog}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleCloseSuccessDialog();
          }
        }}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            bgcolor: "#FFFFFF",
            borderRadius: "20px",
            boxShadow: 3,
            p: 2,
            width: "400px",
          },
        }}
      >
        <IconButton
          onClick={handleCloseSuccessDialog}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} display="flex" justifyContent="center">
              <img
                src={signsuccess}
                alt="รูปภาพ"
                style={{
                  width: 280,
                  height: "auto",
                  marginBottom: "20px",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#333333",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                ยืนยันการเซ็นเอกสารสำเร็จ
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  mt: -1,
                  textAlign: "center",
                  color: "#636363",
                  fontSize: "14px",
                }}
              >
                ทำการยืนยันเซ็นเอกสาร เรียบร้อยแล้ว
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      </>
  );
};

export default DrawSignatureModal;
